export const calculatePrice = (cartItems, isUrgent, discountRanges) => {
  // Handle empty or invalid cartItems
  if (!Array.isArray(cartItems) || cartItems.length === 0) {
    return {
      subtotal: 0,
      discount: 0,
      platformFee: 0,
      finalTotal: 0,
      totalPages: 0,
    };
  }

  // Calculate subtotal with fallback for missing prices and binding prices
  const subtotal = cartItems.reduce((total, item) => {
    const price = typeof item.price === "number" ? item.price : 0;
    // const bindingPrice = typeof item.bindingPrice === "number" ? item.bindingPrice : 0;
    return total + price ;
  }, 0);

  // Calculate total pages using pageRange if available, otherwise totalPages
  const totalPages = cartItems.reduce((total, item) => {
    const pagesPerItem =
      item.pageRange === "all"
        ? typeof item.totalPages === "number"
          ? item.totalPages
          : 0 // Use totalPages if pageRange is "all"
        : item.pageRange
        ? Number(item.pageRange)
        : typeof item.totalPages === "number"
        ? item.totalPages
        : 0; // Otherwise, use pageRange or totalPages

    const copies = typeof item.copies === "number" ? item.copies : 1;
    return total + copies * pagesPerItem;
  }, 0);

  // Determine discount percentage
  let discountPercentage = 0;
  if (Array.isArray(discountRanges)) {
    const applicableRange = discountRanges.find(
      (range) => totalPages >= range.min && totalPages <= range.max
    );
    discountPercentage = applicableRange ? applicableRange.discount / 100 : 0;
  }

  // Calculate financial components
  const discount = subtotal * discountPercentage;
  const platformFeePercentage = subtotal * 0.05; // 5% platform fee
    const platformFee = Math.max(2,  platformFeePercentage);

  const urgentCharge = isUrgent ? Math.max(10, (subtotal - discount) * 0.1) : 0;
  // const urgentCharge = 0;
  const finalTotal = Math.max(0, subtotal - discount + platformFee + urgentCharge);

  return {
    subtotal: Number(subtotal.toFixed(2)),
    discount: Number(discount.toFixed(2)),
    platformFee: Number(platformFee.toFixed(2)),
    urgentCharge: Number(urgentCharge.toFixed(2)),
    finalTotal: Number(finalTotal.toFixed(2)),
    totalPages,
    discountPercentage: discountPercentage * 100,
  };
};
